export default "__VITE_PUBLIC_ASSET__c69b1ad8__"